import { render, staticRenderFns } from "./W0023V0001.vue?vue&type=template&id=89b6a8bc&scoped=true&"
import script from "./W0023V0001.vue?vue&type=script&lang=js&"
export * from "./W0023V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0023V0001.vue?vue&type=style&index=0&id=89b6a8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b6a8bc",
  null
  
)

export default component.exports